import { useEffect, useMemo, useState } from 'react'
import { sanitiseCustomChart } from './helpers'

import { CustomChart } from '../../Dashboard/charts/CustomChart'
import { CustomChart as CustomChartType } from './types'

export const CustomChartPreview = ({
  chart,
  heightClass = 'h-[400px]',
  debounceMs = 300,
}: {
  chart: Partial<CustomChartType>
  heightClass?: string
  debounceMs?: number
}) => {
  const [debouncedChart, setDebouncedChart] = useState(chart)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedChart(chart)
    }, debounceMs)
    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [chart, debounceMs])

  const canShowPreview = useMemo(() => {
    if (
      !debouncedChart.items ||
      !debouncedChart.items.length ||
      !debouncedChart.chartType ||
      !debouncedChart.dataType ||
      !debouncedChart.colorScheme
    )
      return false
    return true
  }, [
    debouncedChart.chartType,
    debouncedChart.colorScheme,
    debouncedChart.dataType,
    debouncedChart.items,
  ])

  if (!canShowPreview)
    return (
      <div
        className={`bg-gray-100 rounded-lg w-full ${heightClass} animate-pulse`}
      />
    )

  return (
    <CustomChart
      chart={sanitiseCustomChart(debouncedChart)}
      heightClass={heightClass}
    />
  )
}
